module.exports = __webpack_public_path__ + "static/img/series.c712edd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/series.png
// module id = AdBN
// module chunks = 6